import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { ToastrService } from 'ngx-toastr';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { ScrumboardService } from '../../scrumboard.service';
import { QueryInterface } from 'app/shared/common/parse/query-interface';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  projectId: any;
  projectName: any;
  boardId: any;
  selectedProject: any = { name: '', id: '' };
  currentHeaderName: string;
  chooseProject: Boolean;
  empRole: any;
  backlogResult = [];
  sprintName: any;
  sprintStartDate: any;
  sprintendDate: any;
  status: any;
  isActiveSprint: boolean;
  back = false;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private parseService: ParseService,
    private toastr: ToastrService,
    private storageConfiguration: StorageConfiguration,
    private _scrumboardService: ScrumboardService,
    private queryInterface: QueryInterface,
  ) {
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
  }

  ngOnInit() {
    this.route.params.subscribe(async params => {
      this.projectId = params.boardId;
      this.projectName = params.boardUri;
    });
    let url = this.router.url.split('/');
    if (url[3] == 'sprint') {
      this.currentHeaderName = 'Backlogs';
      this.chooseProject = true;
    }
    if (url[3] == 'analytics') {
      this.currentHeaderName = 'Analytics';
      this.back = true;
    }
    if (url[3] == 'sprint-dashboard') {
      this.currentHeaderName = 'Sprint Dashboard';
    }
    if (url[3] == 'reports') {
      this.currentHeaderName = 'Reports';
    }
    if (url[3] == 'sprint-list') {
      this.currentHeaderName = 'Sprints';
    }
    if (url[1] == 'scrumboard' && url[2] == 'boards') {
      this.currentHeaderName = 'Active Sprint';
      var queryProfile = new this.parseService.instance.Object('Sprint');
      queryProfile.id = this.projectId;
      this.projectId = queryProfile.get('project').id
      this.getActiveSprint();
      this.isActiveSprint = true;
    }
  }

  async getActiveSprint() {
    let queryInstance = this.parseService.instance.Object.extend('Sprint');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('project', {
      __type: 'Pointer',
      className: 'Project',
      objectId: this.projectId
    });
    query.equalTo('status', 'Active');
    await query.find().then(results => {
      if (results.length > 0) {
        this.sprintName = results[0].get('name');
        this.sprintStartDate = results[0].get('startDate');
        this.sprintendDate = results[0].get('endDate');
        this.status = results[0].get('status');
      }
    });
  }

  sprintDashboard() {
    this.router.navigate(['/scrumboard/board/sprint-dashboard/' + this.projectId + '/' + this.projectName]);
  }

  backlogsLink() {
    this.currentHeaderName = 'Backlogs';
    this.projectId = this.selectedProject.id ? this.selectedProject.id : this.projectId;
    this.projectName = this.selectedProject.name ? this.selectedProject.name : this.projectName;
    this.router.navigate(['/scrumboard/board/sprint/' + this.projectId + '/' + this.projectName]);
  }

  sprintsLink() {
    this.projectId = this.selectedProject.id ? this.selectedProject.id : this.projectId;
    this.projectName = this.selectedProject.name ? this.selectedProject.name : this.projectName;
    this.router.navigate(['/scrumboard/board/sprint-list/' + this.projectId + '/' + this.projectName]);
  }

  analyticsLink() {
    this.projectId = this.selectedProject.id ? this.selectedProject.id : this.projectId;
    this.projectName = this.selectedProject.name ? this.selectedProject.name : this.projectName;
    this.router.navigate(['/scrumboard/board/analytics/' + this.projectId + '/' + this.projectName]);
  }

  reportsLink() {
    this.projectId = this.selectedProject.id ? this.selectedProject.id : this.projectId;
    this.projectName = this.selectedProject.name ? this.selectedProject.name : this.projectName;
    this.router.navigate(['/scrumboard/board/reports/' + this.projectId + '/' + this.projectName]);
  }

  async activeSprint() {
    this.projectId = this.selectedProject.id ? this.selectedProject.id : this.projectId;
    this.projectName = this.selectedProject.name ? this.selectedProject.name : this.projectName;
    let queryInstance = this.parseService.instance.Object.extend('Sprint');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('project');
    query.equalTo('project', {
      __type: 'Pointer',
      className: 'Project',
      objectId: this.projectId
    });
    query.equalTo('status', 'Active');
    await query.find().then(results => {
      if (results.length > 0) {
        let project = results[0].get('project').get('projectInfo');
        this.projectName = project.projectName;
        this.boardId = results[0].id;
        this.router.navigate(['/scrumboard/boards/' + this.boardId + '/' + this.projectName]);
      }
      else {
        this.toastr.warning('There is no active sprint');
      }
    });
  }

  backlocation() {
    this.router.navigate(['on-going-project-list']);
  }


}
